/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  PutApiV1SerieId202,
  PutApiV1SerieId400,
  PutApiV1SerieId401,
  PutApiV1SerieId404,
  PutApiV1SerieId500,
  PutApiV1SerieIdMutationRequest,
  PutApiV1SerieIdMutationResponse,
  PutApiV1SerieIdPathParams,
} from "../../types/serieRegistroController/PutApiV1SerieId.ts";
import { serieViewModelSchema } from "../serieViewModelSchema.ts";

export const putApiV1SerieIdPathParamsSchema = z.object({
  id: z.coerce.number().int(),
}) as unknown as ToZod<PutApiV1SerieIdPathParams>;

/**
 * @description (OK) Resposta com os dados solicitados.
 */
export const putApiV1SerieId202Schema = z.lazy(
  () => serieViewModelSchema,
) as unknown as ToZod<PutApiV1SerieId202>;

/**
 * @description (Bad Request) Requisição em formato incorreto ou com dados faltantes.
 */
export const putApiV1SerieId400Schema =
  z.any() as unknown as ToZod<PutApiV1SerieId400>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const putApiV1SerieId401Schema =
  z.any() as unknown as ToZod<PutApiV1SerieId401>;

/**
 * @description (Not Found) Registro não encontrado.
 */
export const putApiV1SerieId404Schema =
  z.any() as unknown as ToZod<PutApiV1SerieId404>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const putApiV1SerieId500Schema =
  z.any() as unknown as ToZod<PutApiV1SerieId500>;

export const putApiV1SerieIdMutationRequestSchema = z.object({
  CompanyId: z.optional(z.number().int()),
  Title: z.optional(z.string()),
  Resumee: z.optional(z.string()),
  Active: z.optional(z.boolean()),
  IsGeneral: z.optional(z.boolean()),
  Thumbnail: z.optional(z.instanceof(File)),
  RemoveThumbnail: z.optional(z.boolean()),
  ClassStudentIds: z.optional(z.array(z.number().int())),
}) as unknown as ToZod<PutApiV1SerieIdMutationRequest>;

export const putApiV1SerieIdMutationResponseSchema = z.lazy(
  () => putApiV1SerieId202Schema,
) as unknown as ToZod<PutApiV1SerieIdMutationResponse>;
